import type {
  ShiftEmployeeDirectoryManagerRow,
  ShiftEmployeeSelfProfile,
  ShiftSectionSummary,
  ShiftEmployeeUpdateInput,
} from '../../models/employees.types';
import { type EmployeeFormState, type ShiftSectionOption } from './employee-form.types';

export const toFormState = (
  employee: ShiftEmployeeDirectoryManagerRow | ShiftEmployeeSelfProfile,
): EmployeeFormState => ({
  firstName: employee.firstName,
  lastName: employee.lastName,
  email: employee.email ?? '',
  phoneNumber: employee.phoneNumber ?? '',
  sex: employee.sex ?? '',
  birthdate: employee.birthdate ?? '',
  idNumber: employee.idNumber ?? '',
  sectionPk: employee.sectionPk ?? '',
});

export const toNullableText = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const buildEmployeeUpdatePayload = (
  form: EmployeeFormState,
  allowSectionChange: boolean,
  baseline?: EmployeeFormState,
): ShiftEmployeeUpdateInput => {
  const payload: ShiftEmployeeUpdateInput = {
    firstName: form.firstName.trim(),
    lastName: form.lastName.trim(),
    email: toNullableText(form.email),
    phoneNumber: toNullableText(form.phoneNumber),
    sex: form.sex === '' ? null : form.sex,
    birthdate: form.birthdate.trim().length > 0 ? form.birthdate.trim() : null,
    idNumber: toNullableText(form.idNumber),
  };

  if (allowSectionChange) {
    payload.sectionPk = form.sectionPk === '' ? null : form.sectionPk;
  }

  if (baseline) {
    const original = buildEmployeeUpdatePayload(baseline, allowSectionChange);
    return Object.fromEntries(
      Object.entries(payload).filter(([field, value]) => value !== original[field as keyof ShiftEmployeeUpdateInput]),
    );
  }

  return payload;
};

export const toSectionOptions = (sections: ShiftSectionSummary[]): ShiftSectionOption[] =>
  sections.map((section) => ({
    id: section.id,
    name: section.sectionName,
  }));
